import React from "react";
import Sellkyc from "Pages/Sellkyc";


const Sellkyctheme = () => {
  return (
    <React.Fragment>
       <Sellkyc/>
    </React.Fragment>
  );
};

export default Sellkyctheme;
